module.exports = __webpack_public_path__ + "h5/img/guide_logo.1f861b7c.png";